export default "__VITE_ASSET__uRyPq6pU__"